<template>
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
        <path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <circle cx="12" cy="8.5" r="0.5" fill="currentColor" stroke="currentColor" stroke-width="1" />
    </svg>
</template>
